import styled, { css } from "styled-components";
import BackgroundImage from "../../../images/BG.png";

export const Navbar = styled.div`
  display: flex;
  margin: 0 auto;
  padding: 0 16px;
  align-items: center;
  height: 64px;
  background-color: #fdfdfd;
  justify-content: space-between;
  max-width: 1142px;

  img {
    max-height: 40px;
  }
`;

export const Menu = styled.button`
  border: 0;
  height: 40px;
  width: 40px;
  padding: 0.5rem;
  border-radius: 50%;
  background-color: #1f4ca0;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  display: none;

  :hover {
    background-color: #6282bd;
  }

  @media (max-width: 575px) {
    display: inline-block;
  }
`;

export const ButtonsWrapper = styled.div<{ expanded: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 12px;

  a {
    background-color: #1f4ca0;
    color: white !important;
    text-decoration: none;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    border-radius: 14px;
    width: 124px;
    line-height: 16px;
    text-align: center;

    :hover {
      background-color: #6282bd;
    }
  }

  @media (max-width: 575px) {
    display: ${({ expanded }) => (expanded ? "flex" : "none")};
    position: absolute;
    top: 64px;
    padding: 16px;
    left: 0;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 64px);
    background-color: white;
    z-index: 999;
    align-items: center;
    justify-content: start;

    a {
      margin: 0;
      width: 100%;
    }
  }
`;

export const LoginRegisterSection = styled.section`
  background-image: url(${BackgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  padding: 32px 16px;
  display: flex;
`;

export const LoginRegisterSectionContent = styled.div`
  border-radius: 24px;
  padding: 24px 40px;
  width: 100%;
  max-width: 1110px;
  margin: 0 auto;
  border: 2px solid white;
  background-color: transparent;
  backdrop-filter: blur(8px);
`;

export const LoginRegisterForm = styled.div`
  margin: 0 auto;
  max-width: 400px;

  h1 {
    font-size: 24px;
    text-transform: uppercase;
    color: white;
    text-align: center;
    line-height: 1.1;
    margin: 0 auto 32px;
  }
`;

export const Greetings = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  line-height: 20px;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 32px;

  img {
    height: 48px;
  }

  div {
    display: flex;
    flex-direction: column;
    color: rgba(255, 255, 255, 0.8);

    span {
      font-size: 20px;
      font-weight: 700;
      color: white;
    }
  }
`;

export const Tabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  width: 100%;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 16px;
`;

export const Tab = styled.h3<{ active: boolean }>`
  position: relative;
  padding: 0 8px;
  cursor: pointer;
  transition: color 0.3s ease-in-out;

  ${({ active }) =>
    active &&
    css`
      color: white;
    `}

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 4px;
    background-color: white;
    border-radius: 4px;
    opacity: ${({ active }) => (active ? 1 : 0)};
    transition: opacity 0.3s ease-in-out;
  }
`;
